window.addEventListener('DOMContentLoaded', () => {
  $('.copy_content').on('click', (event) => {
    $('#video_description').prepend($('#video_title'));
    utils.copyToClipboard('video_description');
    $('#video_container').prepend($('#video_title'));
    event.preventDefault();
  })
})
